/* eslint-disable import/no-anonymous-default-export */
import { FC } from "react";
import DashboardRoute from "pages/Dashboard/route";
import ChangePassword from "pages/ChangePassword/route";
import UserRoute from "pages/User/route";
import PermissionRoute from "pages/Permission/route";
import MeasurementUnitRoute from "pages/MeasurementUnit/route";
import RegionRoute from "pages/Region/route";
import WarehouseRoute from "pages/Warehouse/route";
import ProductCategoryRoute from "pages/ProductCategory/route";
import ProductRoute from "pages/Product/route";
import InventoryRoute from "pages/Inventory/route";
import PartnerRoute from "pages/Partner/route";
import BankAccountRoute from "pages/BankAccount/route";
import PurchaseOrderRoute from "pages/PurchaseOrder/route";
import CreatePurchaseOrderRoute from "pages/PurchaseOrder/CreatePurchaseOrder/route";
import EditPurchaseOrderRoute from "pages/PurchaseOrder/EditPurchaseOrder/route";
import SalesOrderRoute from "pages/SalesOrder/route";
import CreateSalesOrderRoute from "pages/SalesOrder/pages/CreateSalesOrder/route";
import DetailSalesOrderRoute from "pages/SalesOrder/pages/DetailSalesOrder/route";
import DebtReceiptRoute from "pages/DebtReceipt/route";
import DetailDebtReceiptRoute from "pages/DebtReceipt/DetailDebtReceipt/route";
import DebtRoute from "pages/Debt/route";
import DetailDebtRoute from "pages/Debt/DetailDebt/route";
import ReportRoute from "pages/Report/route";
import ExportJobsRoute from "pages/ExportJobs/route";
import { PermissionRequirement } from "constants/types/permission";

export interface AuthRoute {
  path: string;
  element: FC;
  required?: PermissionRequirement;
}

const EXPORT_ANY: PermissionRequirement = {
  anyOf: [
    "debt:export",
    "inventory:export",
    "partner:export",
    "product:export",
    "purchase_order:export",
    "sale_order:export",
  ],
};

const authRoutes: AuthRoute[] = [
  { ...DashboardRoute, required: { fullAccessOnly: true } },
  ChangePassword,
  { ...UserRoute, required: "user:read" },
  { ...PermissionRoute, required: { fullAccessOnly: true } },
  { ...MeasurementUnitRoute, required: "product:read" },
  { ...RegionRoute, required: "partner:read" },
  { ...WarehouseRoute, required: "warehouse:read" },
  { ...ProductCategoryRoute, required: "product:read" },
  { ...ProductRoute, required: "product:read" },
  { ...InventoryRoute, required: "inventory:read" },
  { ...PartnerRoute, required: "partner:read" },
  { ...BankAccountRoute, required: "payment_journal:read" },
  { ...PurchaseOrderRoute, required: "purchase_order:read" },
  { ...CreatePurchaseOrderRoute, required: "purchase_order:create" },
  { ...EditPurchaseOrderRoute, required: "purchase_order:read" },
  { ...SalesOrderRoute, required: "sale_order:read" },
  { ...CreateSalesOrderRoute, required: "sale_order:create" },
  { ...DetailSalesOrderRoute, required: "sale_order:read" },
  { ...DebtReceiptRoute, required: "debt:read" },
  { ...DetailDebtReceiptRoute, required: "debt:read" },
  { ...DebtRoute, required: "debt:read" },
  { ...DetailDebtRoute, required: "debt:read" },
  { ...ReportRoute, required: "report:read" },
  { ...ExportJobsRoute, required: EXPORT_ANY },
];

export default authRoutes;
